import { createSlice } from '@reduxjs/toolkit';
import {
  FlyingPageState,
  FlightStatusFilterEnum,
  FlightDetail,
  AircraftTypeEnum
} from '../../../types/flyingPage';

const initialState: FlyingPageState = {
  latestFlightDetails: [],
  filters: {
    filterText: undefined,
    status: FlightStatusFilterEnum.ALL,
    aircraftType: ['*'],
    organisationIds: ['*']
  },
  selectedFlightAircraftId: undefined,
  loading: true,
  showFiltersHideSearch: false,
  showAircraftListPanel: true
};

export const flyingPageSlice = createSlice({
  name: 'flyingPage',
  initialState,
  reducers: {
    setSelectedFlightAircraftId: (state, action: { payload: string; type: string }) => {
      state.selectedFlightAircraftId = action.payload;
    },
    clearSelectedFlightAircraftId: state => {
      state.selectedFlightAircraftId = undefined;
    },
    setFilterText: (state, action: { payload: string | undefined; type: string }) => {
      state.filters.filterText = action.payload;
    },
    setLoading: (state, action: { payload: boolean; type: string }) => {
      state.loading = action.payload;
    },
    setLatestFlightDetails: (state, action: { payload: FlightDetail[]; type: string }) => {
      state.latestFlightDetails = action.payload;
    },
    setShowFiltersHideSearch: (state, action: { payload: boolean; type: string }) => {
      state.showFiltersHideSearch = action.payload;
    },
    setShowAircraftListPanel: (state, action: { payload: boolean; type: string }) => {
      state.showAircraftListPanel = action.payload;
    },
    setAircraftTypeFilter: (
      state,
      action: { payload: (AircraftTypeEnum | '*')[]; type: string }
    ) => {
      state.filters.aircraftType = action.payload;
    },
    setOrgFilter: (state, action: { payload: string[]; type: string }) => {
      state.filters.organisationIds = action.payload;
    },
    setStatusFilter: (state, action: { payload: FlightStatusFilterEnum; type: string }) => {
      state.filters.status = action.payload;
    }
  }
});

export const {
  setSelectedFlightAircraftId,
  clearSelectedFlightAircraftId,
  setFilterText,
  setLoading,
  setLatestFlightDetails,
  setShowFiltersHideSearch,
  setShowAircraftListPanel,
  setAircraftTypeFilter,
  setOrgFilter,
  setStatusFilter
} = flyingPageSlice.actions;

export default flyingPageSlice;
